// extracted by mini-css-extract-plugin
export var header = "_al-0";